import { css } from '@emotion/react';
import { PageProps } from 'gatsby';
import { useMemo } from 'react';
import { Footer } from '@/components/general/Footer';
import { Header } from '@/components/general/Header';
import { CookieParts } from '@/components/general/Cookie';
import { Menu } from '@/components/general/Menu';
import { getScreen } from '@/styles/media-query';

export type LayoutProps = {
  children?: React.ReactNode;
  location: PageProps['location'];
};

export const Layout: React.FC<LayoutProps> = ({ children, location }) => {
  const pathname = useMemo(() => location.pathname, [location]);

  return (
    <>
      <Header
        css={css`
          @media ${getScreen('pc-menu', '未満')} {
            display: none;
          }
        `}
        pathname={pathname}
      />
      <Menu
        css={css`
          @media ${getScreen('pc-menu')} {
            display: none;
          }
        `}
        pathname={pathname}
      />
      <main>{children}</main>
      <Footer />
      <CookieParts />
    </>
  );
};
